export function is_number(input){
  return typeof(input) === 'number'
}